<template>
    <c-dialog ref="dialog" width="600" mode="slide" mask-close @close="dialogFormEditConfirm($refs.form, arguments)" @resolve="editHandle">

        <c-form ref="form" vertical unit-width="100%">
            <c-input type="hidden" name="id"></c-input>

            <c-form-item label="售后工单" required >
                <c-select name="order_id" v-model="order_id" async @search="searchAftersaleOrder" :value-data="orderOptions" :clear="false" :disabled="editState"></c-select>
                <info-card code="AFTERSALE_ORDER" :id="order_id"></info-card>
            </c-form-item>

            <c-form-item label="投诉类型" required>
                <c-select name="complaint_type" :options="complaintTypeDic"></c-select>
            </c-form-item>
            <c-form-item label="投诉日期"  required>
                <c-datetime name="complaint_date" type="date" format="yyyy-MM-dd" placeholder="请选择投诉日期"></c-datetime>
            </c-form-item>
            <c-form-item label="被投诉工程师" required>
                <c-select name="complained_user_id" async @search="searchEngineer" :value-data="selectedEngineer" :disabled="order_id <= 0" clearable>
                    <template #option="{data, selected}">
                        <select-option
                                :name="data.name"
                                :info="[
                                `${data.department_name || ''} | ${data.position_name || ''}`
                            ]"
                                :selected="selected"
                        ></select-option>
                    </template>
                </c-select>
            </c-form-item>

            <c-form-item label="问题描述" required>
                <c-input name="issue_description" type="textarea" maxlength="2000" :rows="4" placeholder="请详细描述投诉问题"></c-input>
            </c-form-item>

            <c-form-item label="问题图片">
                <c-upload-file name="issue_images" type="image" media :multiple="true" :sort="false"></c-upload-file>
            </c-form-item>

        </c-form>
    </c-dialog>
</template>

<script>
import {mapState} from "vuex";
export default {
    computed: {
        ...mapState(['complaintTypeDic'])
    },
    data() {
        return {
            order_id: 0,
            orderOptions: [],
            selectedEngineer: [],
            editState: false
        }
    },

    methods: {
        async open(data) {
            this.$refs.form.clear();
            this.order_id = 0;
            this.orderOptions = [];
            this.selectedEngineer = [];
            this.editState = false;

            if (data) {
                this.request({
                    url:'/aftersale/complaint/detail',
                    data: {
                        id:data.id
                    },
                    success:data => {
                        this.$refs.form.set(data);

                        if(data.order_id && data.order_number){
                            this.orderOptions = [{
                                name: data.order_number,
                                value: data.order_id
                            }];
                            this.order_id = data.order_id;
                        }

                        if(data.complained_user_id && data.complained_user_realname){
                            this.selectedEngineer = [{
                                name: data.complained_user_realname,
                                value: data.complained_user_id
                            }];
                        }
                    }
                });
                this.editState = true;
            }else{
                this.$refs.form.set({
                    complaint_type: 1
                });
            }

            this.$refs.dialog.open({
                title: data ? '编辑投诉' : '新增投诉'
            });
        },

        searchAftersaleOrder(keyword, resolve){
            this.request({
                url:'/system/options',
                data: {
                    options_code:'AFTERSALE_ORDER',
                    keyword:keyword
                },
                success:data => {
                    resolve(data);
                }
            })
        },

        searchEngineer(keyword, resolve){
            this.request({
                url:'/after/sale/order/detail/member/list',
                data: {
                   order_id:this.order_id
                },
                success:data => {
                    var selectData = data.map(item => {
                        return {
                            name: item.user_realname,
                            value: item.user_id,
                            position_name: item.position_name,
                            department_name: item.department_name
                        }
                    });
                    resolve(selectData);
                }
            })
        },

        editHandle (stop, next){
            stop();
            this.$refs.form.submit({
                url: this.editState?'/aftersale/complaint/update':'/aftersale/complaint/insert',
                rule: {
                    order_id: '请选择售后工单',
                    complaint_type: '请选择投诉类型',
                    complaint_date: '请选择投诉时间',
                    complained_user_id: '请选择被投诉工程师',
                    issue_description: '请输入问题描述'
                },
                dataFormatter: data => {
                    return data;
                },
                success: (data, res) => {
                    next();
                    this.$message({
                        message: this.editState ? '编辑成功' : '新增成功',
                        type: 'success'
                    });
                    this.$emit('resolve');
                }
            });
        }
    }
}
</script>

<style lang="stylus" scoped>
</style>
